import { FC, Suspense, lazy } from "react";
import { LoadingIndicator } from "../../shared";
import { useAuth } from "@app/shared";

export const LATEST_TERMS_PATH = "/terms_03272024.pdf";

const TermsLazy = lazy(() => import("./TermsLazyLoaded"));

interface TermsProps {
    showActions: boolean;
    nextPage: string;
    previousPage: string;
}

export const Terms: FC<TermsProps> = ({ nextPage, previousPage }) => {
    const { isAuthenticated } = useAuth();

    return (
        <Suspense fallback={<LoadingIndicator />}>
            <TermsLazy showActions={isAuthenticated} latestTermsPath={LATEST_TERMS_PATH} nextPage={nextPage} previousPage={previousPage} />
        </Suspense>
    );
};
